<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">现金流自动分类规则</span>
      <div class="h-panel-right">
        <Button color="primary" @click="addRule">新增规则</Button>
        <Button @click="reload" :loading="loading">刷新</Button>
      </div>
    </div>
    <div class="h-panel-body">
      <Table :datas="mappings" :loading="loading" stripe border>
        <TableItem title="对方科目编码" prop="counterSubjectCode" :width="150"></TableItem>
        <TableItem title="现金方向" :width="100">
          <template slot-scope="{data}">
            <span :class="data.cashDirection === 1 ? 'text-success' : 'text-danger'">
              {{ data.cashDirection === 1 ? '流入' : '流出' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="现金流项目" :width="200">
          <template slot-scope="{data}">
            {{ data.cashFlowItemName || data.cashFlowItemCode }}
          </template>
        </TableItem>
        <TableItem title="匹配方式" :width="100">
          <template slot-scope="{data}">
            {{ data.matchType === 1 ? '精确' : '前缀' }}
          </template>
        </TableItem>
        <TableItem title="优先级" prop="priority" :width="100"></TableItem>
        <TableItem title="状态" :width="80">
          <template slot-scope="{data}">
            <span :class="data.enabled ? 'text-success' : 'text-muted'">
              {{ data.enabled ? '启用' : '禁用' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="备注" prop="remark" :width="200"></TableItem>
        <TableItem title="操作" :width="150" align="center">
          <template slot-scope="{data}">
            <Button size="small" @click="editRule(data)">编辑</Button>
            <Button size="small" color="error" @click="deleteRule(data)">删除</Button>
          </template>
        </TableItem>
      </Table>

      <Modal v-model="ruleModal.visible" :title="ruleModal.title" :width="600">
        <Form :model="ruleModal.form" :label-width="120" ref="ruleForm">
          <FormItem label="对方科目编码" prop="counterSubjectCode" required>
            <Input v-model="ruleModal.form.counterSubjectCode" placeholder="例如：1122"></Input>
          </FormItem>
          <FormItem label="现金方向" prop="cashDirection" required>
            <RadioGroup v-model="ruleModal.form.cashDirection">
              <Radio :label="1">流入</Radio>
              <Radio :label="2">流出</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="现金流项目" prop="cashFlowItemCode" required>
            <Select v-model="ruleModal.form.cashFlowItemCode" :datas="cashFlowItems" filterable></Select>
          </FormItem>
          <FormItem label="匹配方式" prop="matchType" required>
            <RadioGroup v-model="ruleModal.form.matchType">
              <Radio :label="1">精确匹配</Radio>
              <Radio :label="2">前缀匹配</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="优先级" prop="priority">
            <InputNumber v-model="ruleModal.form.priority" :min="1" :max="9999"></InputNumber>
            <div class="form-tip">数值越大优先级越高，默认100</div>
          </FormItem>
          <FormItem label="状态" prop="enabled">
            <Checkbox v-model="ruleModal.form.enabled">启用</Checkbox>
          </FormItem>
          <FormItem label="备注" prop="remark">
            <Input v-model="ruleModal.form.remark" type="textarea" :rows="3"></Input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button @click="ruleModal.visible = false">取消</Button>
          <Button color="primary" @click="saveRule" :loading="ruleModal.loading">保存</Button>
        </div>
      </Modal>
    </div>
  </app-content>
</template>

<script>
export default {
  name: 'CashFlowRules',
  data() {
    return {
      loading: false,
      mappings: [],
      cashFlowItems: [],
      ruleModal: {
        visible: false,
        title: '',
        isEdit: false,
        form: {
          id: null,
          counterSubjectCode: '',
          cashDirection: 1,
          cashFlowItemCode: '',
          matchType: 2,
          priority: 100,
          enabled: true,
          remark: ''
        },
        loading: false
      }
    };
  },
  created() {
    this.loadCashFlowItems();
    this.reload();
  },
  methods: {
    async loadCashFlowItems() {
      try {
        const res = await this.$api.cashflow.items.list();
        if (res.success) {
          this.cashFlowItems = res.data.map(item => ({
            value: item.code,
            label: `${item.name} (${item.code})`
          }));
        }
      } catch (e) {
        console.error('加载现金流项目失败', e);
      }
    },
    async reload() {
      this.loading = true;
      try {
        const res = await this.$api.cashflow.mappings.list();
        if (res.success) {
          this.mappings = res.data || [];
        } else {
          this.$Message.error(res.msg || '加载失败');
        }
      } catch (e) {
        console.error('加载规则列表失败', e);
        this.$Message.error('加载失败');
      } finally {
        this.loading = false;
      }
    },
    addRule() {
      this.ruleModal.isEdit = false;
      this.ruleModal.title = '新增规则';
      this.ruleModal.form = {
        id: null,
        counterSubjectCode: '',
        cashDirection: 1,
        cashFlowItemCode: '',
        matchType: 2,
        priority: 100,
        enabled: true,
        remark: ''
      };
      this.ruleModal.visible = true;
    },
    editRule(rule) {
      this.ruleModal.isEdit = true;
      this.ruleModal.title = '编辑规则';
      this.ruleModal.form = { ...rule };
      this.ruleModal.visible = true;
    },
    async saveRule() {
      if (!this.ruleModal.form.counterSubjectCode) {
        this.$Message.warning('请输入对方科目编码');
        return;
      }
      if (!this.ruleModal.form.cashFlowItemCode) {
        this.$Message.warning('请选择现金流项目');
        return;
      }

      this.ruleModal.loading = true;
      try {
        const api = this.ruleModal.isEdit
          ? this.$api.cashflow.mappings.update
          : this.$api.cashflow.mappings.save;
        
        const res = await api(this.ruleModal.form);
        if (res.success) {
          this.$Message.success('保存成功');
          this.ruleModal.visible = false;
          this.reload();
        } else {
          this.$Message.error(res.msg || '保存失败');
        }
      } catch (e) {
        console.error('保存规则失败', e);
        this.$Message.error('保存失败');
      } finally {
        this.ruleModal.loading = false;
      }
    },
    deleteRule(rule) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除规则 "${rule.counterSubjectCode} -> ${rule.cashFlowItemName || rule.cashFlowItemCode}" 吗？`,
        onOk: async () => {
          try {
            const res = await this.$api.cashflow.mappings.delete(rule.id);
            if (res.success) {
              this.$Message.success('删除成功');
              this.reload();
            } else {
              this.$Message.error(res.msg || '删除失败');
            }
          } catch (e) {
            console.error('删除规则失败', e);
            this.$Message.error('删除失败');
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.text-success {
  color: #19be6b;
}
.text-danger {
  color: #ed4014;
}
.text-muted {
  color: #999;
}
.form-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
</style>
